/** Must stay aligned with AIAssistantCommand.MaximumMessageCharacters. */
export const MAXIMUM_ASSISTANT_MESSAGE_CHARACTERS = 8_000;

export default class AssistantAPICommand {
  public message?: string;
  public conversationId?: string;
  public currentRoute?: string;
}
